import React, { useEffect, useState } from 'react'

interface IPdfViewerProps {
  file: any;
  loader?: boolean;
  showPreview?: boolean;
}


const RawPdfViewer = React.memo<IPdfViewerProps>((props: IPdfViewerProps) => {
  const [directed, setDirected] = useState<any>();
  const imgTypes = ['jpg','jpeg','png','image/jpeg','image/jpg','image/png'];
  const pdfTypes = ['pdf','application/pdf']
  const { file } = props;
  const direct = () => {
    if(file?.value){
      const binaryString = atob(file?.value);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      const blobed = new Blob([bytes], { type: 'application/pdf' });
      setDirected(blobed)
    }else{
      setDirected(file)
    }
  }

  useEffect(() => {
    direct()
  }, [file?.value])
  return (
    <>
   {imgTypes?.includes(file?.type) && <div>
       {directed && <img
          src={URL.createObjectURL(directed)}
          alt="Preview"
          className='raw-pdf-panel'
        /> }
    </div>}

    {pdfTypes?.includes(file?.type) && <div className='raw-pdf-viewer'>
      {directed && <iframe
        src={URL.createObjectURL(directed)}
        title="PDF Viewer"
         className='raw-pdf-panel'
      ></iframe>}
    </div>}
    </>
  )
})

export default RawPdfViewer